import React, { createContext, forwardRef, useContext, useEffect, useRef, useState, } from "react";

const PageTitle = ({
    title = '建立文案',
    subTitle = '請選擇一種方式開始建立您的圖框樣式',
    color = "#134e4a",   // text-teal-800
    subTitlecolor = "#0d9488",   // text-teal-600
    bgcolor = { backgroundImage: "linear-gradient(to right, #f0fdfa, #f0fdf4)" },
}) => {
    return (<>
        <div className="container-fluid max-w-full">
            <div
                className="
                    mb-6 rounded-lg
                    bg-gradient-to-r from-teal-50 to-green-50
                    border-b border-teal-100
                    p-4 pb-6
                "
                style={bgcolor || {}}
            >
                <div className="flex flex-col items-start gap-1">
                    <p
                        className="text-3xl font-bold tracking-tight"
                        style={{ color: color || "#134e4a" }} // text-teal-800
                    >
                        {title || "選擇建立方式"}
                    </p>
                    {subTitle && <p
                        className="text-sm md:text-base"
                        style={{ color: subTitlecolor || "#0d9488" }} // text-teal-600
                    >
                        {subTitle || "請選擇一種方式開始建立您的文案"}
                    </p>}
                </div>
            </div>
        </div>
    </>)
}
export default PageTitle